import Styles from './NodeInfoLayout.module.scss'
import React, { useState } from 'react';
import { Grid, Card, Icon } from 'components/lib';
import { ListItemText, List, ListItem, Typography } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { VideoPopup } from 'components/global/VideoPopup/VideoPopup';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { ImagePopup } from 'components/global//ImagePopup/ImagePopup';


export function NodeInfoLayout({ goals, descr, video, startButton, name, subtitle, isAssessment, ...props }) {

    goals = (goals.trim()).split(/\./);
    descr = (descr.trim()).split("|||");
    const [showInfo, setShowInfo] = useState(false);

    const showChallengeInfo = () => {
        setShowInfo(true);
    };

    const hideChallengeInfo = () => {
        setShowInfo(false);
    };

    return (
        <>
            {video && video?.split('.').pop() === 'png' ? (
                <ImagePopup
                    showInfo={showInfo}
                    hideImageInfo={() => {
                        hideChallengeInfo();
                    }}
                    imageSrc={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${video}`}
                />
            ) : (
                <VideoPopup
                    showInfo={showInfo}
                    hideChallengeInfo={() => {
                        hideChallengeInfo();
                    }}
                    videoSrc={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${video}`}
                />
            )}

            <Card className={Styles.headerContainer} shadow>
                <div>
                    <BreadCrumbs
                        disableHome
                        onClickPaths={[
                            -1,
                        ]}
                        crumbs={[
                            <div style={{ display: "flex", alignItems: "center", gap: '3px' }}><Icon image='arrow-left' size={25} />{props.t('Labs.InfoForNodes.NodeInfo.back')}</div>,
                        ]}
                    />
                    <div id='titleContainer' className={Styles.titleContainer}>
                        <Typography
                            sx={{
                                textTransform: 'uppercase',
                                // color: 'black',
                                color: 'darkslategray',
                                fontWeight: "600",
                                fontFamily: ' Roboto, sans-serif',
                                fontSize: '37px'
                            }}>
                            {name}
                        </Typography>
                        <Typography
                            sx={{
                                textTransform: 'uppercase',
                                marginTop: '0.5rem',
                                fontSize: '16px',
                            }}>
                            {subtitle}
                        </Typography>
                    </div>
                </div>

                <div id='startButtonContainer' className={Styles.startButtonContainer}>
                    <button
                        className={Styles.startButton}
                        onClick={startButton}
                    >
                        <KeyboardDoubleArrowDownIcon />
                        {props.t('Labs.InfoForNodes.NodeInfo.button')}
                    </button>
                </div>
            </Card>

            <Grid cols='2'>
                <Card className={Styles.descrContainer} shadow>
                    <div id='descrTitleHolder'
                        style={{
                            borderRadius: "8px",
                            backgroundColor: "inherit"
                        }}>
                        <Typography
                            variant="h4"
                            gutterBottom
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                fontWeight: "700",
                                color: 'darkslategray'
                            }}
                        >
                            {props.t('Labs.InfoForNodes.NodeInfo.description')}
                        </Typography>
                    </div>
                    <div
                        id='videoContainer'
                        className={Styles.videoContainer}
                        style={{
                            display: isAssessment === 1 || !video ? "none" : ""
                        }}
                        onClick={() => showChallengeInfo()}
                    >
                        {video && video?.split('.')?.pop() === 'png' ? (
                            <img
                                disablePictureInPicture
                                src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${video}`}
                                alt={props.t('Labs.InfoForNodes.NodeInfo.video.warning')}
                                className={Styles.imageGif}
                                onContextMenu={(e) => {
                                    e.preventDefault();
                                    return false;
                                }}
                            />
                        ) : (
                            <video disablePictureInPicture autoPlay muted loop controls className={Styles.videoGif} controlsList="nodownload">
                                <source src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${video}`} type="video/mp4" />
                                {props.t('Labs.InfoForNodes.NodeInfo.video.warning')}
                            </video>
                        )}
                    </div>

                    <List id='descrList' key='descrListNode' className={Styles.descrList}>
                        {descr.map((label, index) => {
                            if (label && label.trim() !== '') {
                                return (
                                    <React.Fragment key={`li-descrList-${index}`}>

                                        <ListItem>
                                            <ListItemText sx={{
                                                fontFamily: 'roboto',
                                                color: "black",
                                                textAlign: "justify",
                                                marginBottom: '-5px'

                                            }} >
                                                <div className={Styles.descContent}> <Typography variant="body1" style={{ fontSize: '16px' }}>{label}</Typography></div>
                                            </ListItemText>
                                        </ListItem>
                                    </React.Fragment>
                                );
                            }
                            return null; // Skip rendering if label is empty or falsy
                        })}
                    </List>
                </Card>

                <Card className={Styles.goalsContainer} shadow>
                    <div
                        id='goalTitleHolder'
                        style={{
                            borderRadius: "8px",
                            backgroundColor: "inherit",
                        }}>
                        <Typography
                            variant="h4"
                            gutterBottom
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                // color: 'black'
                                color: 'darkslategray',
                                fontWeight: "700"
                            }}
                        >
                            {props.t('Labs.InfoForNodes.NodeInfo.goals')}
                        </Typography>
                    </div>
                    <div
                        id='goalsHolder'
                        className={Styles.goalsHolder}>
                        <List id='goalsList' key='goalsListNode'>
                            {goals.map((label, index) => {
                                if (label && label.trim() !== '') {
                                    return (
                                        <React.Fragment key={`li-goalList-${index}`}>
                                            <ListItem >
                                                <ListItemText sx={{
                                                    fontFamily: 'roboto',
                                                    color: "black",
                                                    textAlign: "justify",
                                                    marginBottom: '-5px'

                                                }} >
                                                    <div className={Styles.listItem}>
                                                        <FiberManualRecordIcon fontSize='small' sx={{ marginRight: '10px', paddingTop: '5px' }} />
                                                        <Typography variant="body1" style={{ fontSize: '16px' }}>{label}</Typography>
                                                    </div>
                                                </ListItemText>
                                            </ListItem>
                                        </React.Fragment>
                                    );
                                }
                                return null;
                            })}
                        </List>
                    </div >
                </Card>
            </Grid >
        </>
    );
}